import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import { LoadingState } from "../components/ui/spinner";

export default function ProtectedRoute({ children }) {
  const { user, loading, profileReady } = useAuth();
  const location = useLocation();

  if (loading || (user && !profileReady)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingState message="Loading..." />
      </div>
    );
  }

  // An anonymous user (link-shared guest) is NOT authenticated for any route
  // other than the dedicated guest poll route (which uses GuestRoute, not this).
  // Treat isAnonymous exactly like a logged-out visitor so dashboard/create/etc
  // redirect a guest to real sign-in.
  if (!user || user.isAnonymous) {
    localStorage.setItem("postLoginRedirect", location.pathname + location.search);
    return <Navigate to="/auth" replace />;
  }

  return children;
}
